import React from 'react'
import { Divider, makeStyles, shorthands, tokens } from '@fluentui/react-components'
import { TooltipProps } from 'recharts'
import { t } from '../../i18n/i18n'
import { Activity } from '../../api/schemas/schema'
import { formatDate } from '../../helpers/stringHelper'
import { Text } from '../common/text/Text'
const useStyles = makeStyles({
   tooltip: {
      position: 'fixed',
      pointerEvents: 'none',
      background: 'white',
      borderRadius: tokens.borderRadiusXLarge,
      ...shorthands.padding(tokens.spacingVerticalXXS, tokens.spacingHorizontalL),
      boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
      fontSize: tokens.fontSizeBase400,
      maxWidth: '600px',
   },
   startDate: {
      fontSize: tokens.fontSizeBase400,
      marginBottom: tokens.spacingVerticalS,
   },
   endDate: {
      fontSize: tokens.fontSizeBase400,
      marginBottom: tokens.spacingVerticalM,
   },
   description: {
      fontSize: tokens.fontSizeBase400,
   },
   title: {
      wordBreak: 'break-word',
   },
})
type ActivityTooltipProps = TooltipProps<any, any> & {
   activities: Activity[]
   hover: { id: string; x: number; y: number } | null
}

export const ActivityTooltip = ({ activities, hover }: ActivityTooltipProps) => {
   const classes = useStyles()

   const findActivity = (id: string) => activities.find((a) => a.id === id)

   if (!hover) return null
   const activity = findActivity(hover.id)
   if (!activity) return null

   return (
      <article
         className={classes.tooltip}
         style={{
            left: hover.x,
            top: hover.y,
         }}
      >
         <Text className={classes.title} weight="medium">
            {activity.title}
         </Text>
         <Divider appearance="brand" />

         <Text className={classes.startDate}>
            {t('StartDate')}: {formatDate(activity.startDate)}
         </Text>
         <Text className={classes.endDate}>
            {t('EndDate')}: {formatDate(activity.endDate)}
         </Text>
         {!!activity.description && (
            <>
               <Divider appearance="subtle" />
               <Text className={classes.description}>{activity.description}</Text>
            </>
         )}
      </article>
   )
}
